import React, { lazy, Suspense } from "react";
import { DashboardLayer } from "../../../shared/dashboardLayer/DashboardLayer";
import { Route, Routes } from "react-router-dom";
import { GlobalLoader } from "../../../shared/loaders/globalLoader/GlobalLoader";
import { Page404 } from "../../../pages/page404/Page404";

const Clients = lazy(() => import("../../../pages/clients/Clients"));
const Library = lazy(() => import("../../../pages/library/Library"));
const Logout = lazy(() => import("../../../pages/auth/logout/Logout"));
const AuditOnsiteList = lazy(
  () => import("../../../pages/audits/auditOnsiteLIst/AuditOnsiteList")
);
const AuditOnSite = lazy(
  () => import("../../../pages/audits/auditOnSite/AuditOnSite")
);
const ActionList = lazy(
  () => import("../../../pages/audits/actionList/ActionList")
);
const Action = lazy(() => import("../../../pages/audits/action/Action"));
const Reports = lazy(() => import("../../../pages/reports/Reports"));
const ChangePassword = lazy(
  () => import("../../../pages/auth/changePassword/ChangePassword")
);
const SingleComment = lazy(
  () => import("../../../pages/audits/actionList/singleComment/SingleComment")
);
const Home = lazy(() => import("../../../pages/home/Home"));
const PrivacyPolicy = lazy(
  () => import("../../../pages/privacyPolicy/PrivacyPolicy")
);
const TermsOfUse = lazy(() => import("../../../pages/termsOfUse/TermsOfUse"));

export const RoutesAuditor = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Home />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/clients"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Clients />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/settings"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <ChangePassword />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/library"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Library />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/reports"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Reports />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/audits-onsite"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <AuditOnsiteList />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/audits-onsite/:auditOnSiteId"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <AuditOnSite />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/action-list"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <ActionList />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/action-list/:actionId"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Action />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/client/:clientId/action-list/:actionId/comment/:commentId"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <SingleComment />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/logout"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Logout />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/privacy-policy"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <PrivacyPolicy />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/terms-of-use"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <TermsOfUse />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/change-password/:token"
        element={
          <Suspense fallback={<GlobalLoader />}>
            <ChangePassword />
          </Suspense>
        }
      />
      <Route
        path="*"
        element={
          <DashboardLayer>
            <Page404 />
          </DashboardLayer>
        }
      />
    </Routes>
  );
};
